// Sample with Drupal behavior when you have dynamically generated or cached datas
// Pause the video on the homepage when the foundation `Reveal` component is closed
(function ($, Drupal) {
  Drupal.behaviors.revealHome = {
    attach: function (context, settings) {
      $('#home-video-modal', context).on('closed.zf.reveal', function(){
        document.querySelector('#home-video-full').pause();
      });
    }
  }
})(jQuery, Drupal);
